import { makeStyles } from 'tss-react/mui';

const useStylesCompletionBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  completionBlock: {
    minWidth: 120,
  },
  completionRightOffset: {
    marginRight: 20,
  },
  completionBlockTotal: {
    marginLeft: 5,
  },
  completionBlockProgress: {
    minWidth: 120,
    maxWidth: 500,
  },
  completionBlockProgressBottom: {
    width: '100%',
    marginTop: 5,
  },
  completionBlockProgressLeft: {
    marginRight: 10,
  },
}));

export default useStylesCompletionBlock;
